import { render, staticRenderFns } from "./RotatingBannerSystem.vue?vue&type=template&id=96a0ea10&scoped=true"
import script from "./RotatingBannerSystem.vue?vue&type=script&lang=js"
export * from "./RotatingBannerSystem.vue?vue&type=script&lang=js"
import style0 from "./RotatingBannerSystem.vue?vue&type=style&index=0&id=96a0ea10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a0ea10",
  null
  
)

export default component.exports